const city = [
  {
    id: 1,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 26/27 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2026",
      "2026 manchester",
      "2026",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/26-27-01/uni0.jpg",
      "/images/europa/mcity/26-27-01/uni1.jpg",
      "/images/europa/mcity/26-27-01/uni2.jpg",
      "/images/europa/mcity/26-27-01/uni3.jpg",
      "/images/europa/mcity/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2025",
      "2025 manchester",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/25-26-01/uni0.jpg",
      "/images/europa/mcity/25-26-01/uni1.jpg",
      "/images/europa/mcity/25-26-01/uni2.jpg",
      "/images/europa/mcity/25-26-01/uni3.jpg",
      "/images/europa/mcity/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2025",
      "2025 manchester",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/25-26-02/uni0.jpg",
      "/images/europa/mcity/25-26-02/uni1.jpg",
      "/images/europa/mcity/25-26-02/uni2.jpg",
      "/images/europa/mcity/25-26-02/uni3.jpg",
      "/images/europa/mcity/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2025",
      "2025 manchester",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/25-26-03/uni0.jpg",
      "/images/europa/mcity/25-26-03/uni1.jpg",
      "/images/europa/mcity/25-26-03/uni2.jpg",
      "/images/europa/mcity/25-26-03/uni3.jpg",
      "/images/europa/mcity/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 25/26 - Uniforme 4",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2025",
      "2025 manchester",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/25-26-04/uni0.jpg",
      "/images/europa/mcity/25-26-04/uni1.jpg",
      "/images/europa/mcity/25-26-04/uni2.jpg",
      "/images/europa/mcity/25-26-04/uni3.jpg",
      "/images/europa/mcity/25-26-04/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2025",
      "2025 manchester",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/25-26-00/uni0.jpg",
      "/images/europa/mcity/25-26-00/uni1.jpg",
      "/images/europa/mcity/25-26-00/uni2.jpg",
      "/images/europa/mcity/25-26-00/uni3.jpg",
      "/images/europa/mcity/25-26-00/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2024",
      "2024 manchester",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/24-25-01/uni0.jpg",
      "/images/europa/mcity/24-25-01/uni1.jpg",
      "/images/europa/mcity/24-25-01/uni2.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2024",
      "2024 manchester",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/24-25-02/uni0.jpg",
      "/images/europa/mcity/24-25-02/uni1.jpg",
      "/images/europa/mcity/24-25-02/uni2.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2024",
      "2024 manchester",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/24-25-03/uni0.jpg",
      "/images/europa/mcity/24-25-03/uni1.jpg",
      "/images/europa/mcity/24-25-03/uni2.jpg",
      "/images/europa/mcity/24-25-03/uni3.jpg",
      "/images/europa/mcity/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2024",
      "2024 manchester",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/24-25-03/uni0.jpg",
      "/images/europa/mcity/24-25-03/uni1.jpg",
      "/images/europa/mcity/24-25-03/uni2.jpg",
      "/images/europa/mcity/24-25-03/uni3.jpg",
      "/images/europa/mcity/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2024",
      "2024 manchester",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/24-25-00-es-l/uni0.jpg",
      "/images/europa/mcity/24-25-00-es-l/uni1.jpg",
      "/images/europa/mcity/24-25-00-es-l/uni2.jpg",
      "/images/europa/mcity/24-25-00-es-l/uni3.jpg",
      "/images/europa/mcity/24-25-00-es-l/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 23/24 - Uniforme de Goleiro (Verde)",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2023",
      "2023 manchester",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/23-24-05-gv/uni0.jpg",
      "/images/europa/mcity/23-24-05-gv/uni1.jpg",
      "/images/europa/mcity/23-24-05-gv/uni2.jpg",
      "/images/europa/mcity/23-24-05-gv/uni3.jpg",
      "/images/europa/mcity/23-24-05-gv/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2022",
      "2022 manchester",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/22-23-01/uni0.jpg",
      "/images/europa/mcity/22-23-01/uni1.jpg",
      "/images/europa/mcity/22-23-01/uni2.jpg",
      "/images/europa/mcity/22-23-01/uni3.jpg",
      "/images/europa/mcity/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 22/23 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2022",
      "2022 manchester",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/22-23-02/uni0.jpg",
      "/images/europa/mcity/22-23-02/uni1.jpg",
      "/images/europa/mcity/22-23-02/uni2.jpg",
      "/images/europa/mcity/22-23-02/uni3.jpg",
      "/images/europa/mcity/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 22/23 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2022",
      "2022 manchester",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/22-23-03/uni0.jpg",
      "/images/europa/mcity/22-23-03/uni1.jpg",
      "/images/europa/mcity/22-23-03/uni2.jpg",
      "/images/europa/mcity/22-23-03/uni3.jpg",
      "/images/europa/mcity/22-23-03/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 22/23 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2022",
      "2022 manchester",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/22-23-00-es/uni0.jpeg",
      "/images/europa/mcity/22-23-00-es/uni1.jpeg",
      "/images/europa/mcity/22-23-00-es/uni2.jpeg",
      "/images/europa/mcity/22-23-00-es/uni3.jpeg",
      "/images/europa/mcity/22-23-00-es/uni4.jpeg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 22/23 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2022",
      "2022 manchester",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/22-23-00-es-1/uni0.png",
      "/images/europa/mcity/22-23-00-es-1/uni1.png",
      "/images/europa/mcity/22-23-00-es-1/uni2.png",
      "/images/europa/mcity/22-23-00-es-1/uni3.png",
      "/images/europa/mcity/22-23-00-es-1/uni4.png",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2021",
      "2021 manchester",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/21-22-01/uni0.jpg",
      "/images/europa/mcity/21-22-01/uni1.jpg",
      "/images/europa/mcity/21-22-01/uni2.jpg",
      "/images/europa/mcity/21-22-01/uni3.jpg",
      "/images/europa/mcity/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2021",
      "2021 manchester",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/21-22-02/uni0.jpg",
      "/images/europa/mcity/21-22-02/uni1.jpg",
      "/images/europa/mcity/21-22-02/uni2.jpg",
      "/images/europa/mcity/21-22-02/uni3.jpg",
      "/images/europa/mcity/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 21/22 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2021",
      "2021 manchester",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/21-22-00-es/uni0.jpg",
      "/images/europa/mcity/21-22-00-es/uni1.jpg",
      "/images/europa/mcity/21-22-00-es/uni2.jpg",
      "/images/europa/mcity/21-22-00-es/uni3.jpg",
      "/images/europa/mcity/21-22-00-es/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 19/20 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2019",
      "2019 manchester",
      "2019",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/19-20-01-rt/uni0.png",
      "/images/europa/mcity/19-20-01-rt/uni1.png",
      "/images/europa/mcity/19-20-01-rt/uni2.png",
      "/images/europa/mcity/19-20-01-rt/uni3.png",
      "/images/europa/mcity/19-20-01-rt/uni4.png",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 15/16 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2015",
      "2015 manchester",
      "2015",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/15-16-02-rt/uni0.jpg",
      "/images/europa/mcity/15-16-02-rt/uni1.jpg",
      "/images/europa/mcity/15-16-02-rt/uni2.jpg",
      "/images/europa/mcity/15-16-02-rt/uni3.jpg",
      "/images/europa/mcity/15-16-02-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 13/14 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2013",
      "2013 manchester",
      "2013",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/13-14-02-rt/uni0.png",
      "/images/europa/mcity/13-14-02-rt/uni1.png",
      "/images/europa/mcity/13-14-02-rt/uni2.png",
      "/images/europa/mcity/13-14-02-rt/uni3.png",
      "/images/europa/mcity/13-14-02-rt/uni4.png",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 11/12 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2011",
      "2011 manchester",
      "2011",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/11-12-01-rt/uni0.jpg",
      "/images/europa/mcity/11-12-01-rt/uni1.jpg",
      "/images/europa/mcity/11-12-01-rt/uni2.jpg",
      "/images/europa/mcity/11-12-01-rt/uni3.jpg",
      "/images/europa/mcity/11-12-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 07/08 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2007",
      "2007 manchester",
      "2007",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/07-08-02-rt/uni0.jpg",
      "/images/europa/mcity/07-08-02-rt/uni1.jpg",
      "/images/europa/mcity/07-08-02-rt/uni2.jpg",
      "/images/europa/mcity/07-08-02-rt/uni3.jpg",
      "/images/europa/mcity/07-08-02-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 01/02 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 2001",
      "2001 manchester",
      "2001",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/01-02-01-rt/uni0.jpg",
      "/images/europa/mcity/01-02-01-rt/uni1.jpg",
      "/images/europa/mcity/01-02-01-rt/uni2.jpg",
      "/images/europa/mcity/01-02-01-rt/uni3.jpg",
      "/images/europa/mcity/01-02-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 99/01 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 1999",
      "1999 manchester",
      "1999",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/99-01-01-rt/uni0.jpeg",
      "/images/europa/mcity/99-01-01-rt/uni1.jpeg",
      "/images/europa/mcity/99-01-01-rt/uni2.jpeg",
      "/images/europa/mcity/99-01-01-rt/uni3.jpeg",
      "/images/europa/mcity/99-01-01-rt/uni4.jpeg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 1994",
      "1994 manchester",
      "1994",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/94-95-02-rt/uni0.jpeg",
      "/images/europa/mcity/94-95-02-rt/uni1.jpeg",
      "/images/europa/mcity/94-95-02-rt/uni2.jpeg",
      "/images/europa/mcity/94-95-02-rt/uni3.jpeg",
      "/images/europa/mcity/94-95-02-rt/uni4.jpeg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 93/94 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 1993",
      "1993 manchester",
      "1993",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/93-94-02-rt/uni0.jpg",
      "/images/europa/mcity/93-94-02-rt/uni1.jpg",
      "/images/europa/mcity/93-94-02-rt/uni2.jpg",
      "/images/europa/mcity/93-94-02-rt/uni3.jpg",
      "/images/europa/mcity/93-94-02-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 89/90 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 1989",
      "1989 manchester",
      "1989",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/89-90-01-rt/uni0.jpg",
      "/images/europa/mcity/89-90-01-rt/uni1.jpg",
      "/images/europa/mcity/89-90-01-rt/uni2.jpg",
      "/images/europa/mcity/89-90-01-rt/uni3.jpg",
      "/images/europa/mcity/89-90-01-rt/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City 81/82 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester 1981",
      "1981 manchester",
      "1981",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester city retro",
      "retro city manchester",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mcity/81-82-01-rt/uni0.jpg",
      "/images/europa/mcity/81-82-01-rt/uni1.jpg",
      "/images/europa/mcity/81-82-01-rt/uni2.jpg",
      "/images/europa/mcity/81-82-01-rt/uni3.jpg",
      "/images/europa/mcity/81-82-01-rt/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City - Jaqueta",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester jaqueta",
      "jaqueta manchester",
      "jaqueta",
      "manchester city jaqueta",
      "jaqueta city manchester",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/ja/uni0.jpg",
      "/images/europa/mcity/ja/uni1.jpg",
      "/images/europa/mcity/ja/uni2.jpg",
      "/images/europa/mcity/ja/uni3.jpg",
      "/images/europa/mcity/ja/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-city",
    nome: "Manchester City - Jaqueta",
    tipo: "masculino",
    aliases: [
      "manchester city",
      "manchester",
      "the citizens",
      "manchester jaqueta",
      "jaqueta manchester",
      "jaqueta",
      "manchester city jaqueta",
      "jaqueta city manchester",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mcity/ja1/uni0.jpg",
      "/images/europa/mcity/ja1/uni1.jpg",
      "/images/europa/mcity/ja1/uni2.jpg",
      "/images/europa/mcity/ja1/uni3.jpg",
      "/images/europa/mcity/ja1/uni4.jpg",
    ],
  },
];

export default city;
